import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * "Tech voices": frases reales de técnicos y fuentes del oficio (VOC de la
 * ficha), con fuente. No se presentan como reseñas del producto.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-paper-dark';
  return <section aria-label={title} className={`w-full text-pine ${bg}`} data-id="element-347" data-mp="2x0thcizxumod">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-348" data-mp="2x11pjxl493t8">
        <div className="text-center" data-id="element-349" data-mp="2s2rxhvuoujbu">
          <p className="eyebrow text-ember-deep" data-id="element-350" data-mp="2s3t9c2jj39um">Tech to tech</p>
          <h2 className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-351" data-mp="v8dite99jy8p">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-352" data-mp="h5y6c818d10g">
            Real words from refrigeration techs and the trade. This is exactly
            the call Ice Machine Diagnostic Pro was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-353" data-mp="78tryudmm9u7">
          {voices.map(item => <figure key={item.quote} className="spec-card rounded-2xl border border-paper-dark bg-paper p-6" data-id="element-354" data-mp="c7n0s9hyxco1">
              <QuoteIcon className="h-7 w-7 text-sky-deep" aria-hidden="true" data-id="element-355" data-mp="14v9cy659hpmi" />
              <blockquote className="mono-note mt-2 text-lg leading-snug text-pine" data-id="element-356" data-mp="14xdewijloek5">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-pine-soft" data-id="element-357" data-mp="v4xvdgsnnhx5">
                <span className="block text-[13px] font-bold text-pine" data-id="element-358" data-mp="1ivadfkhm6v1g">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-pine-muted" data-id="element-359" data-mp="1xi92x9wwvfdj">
          Quoted as written from trade publications and public tech forums. Not
          reviews of this product.
        </p>
      </div>
    </section>;
}